import { render } from "./CambiarContrasena.vue?vue&type=template&id=230f5afe&scoped=true"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js"

import "./CambiarContrasena.vue?vue&type=style&index=0&id=230f5afe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230f5afe"]])

export default __exports__